import actionCreatorFactory from 'typescript-fsa';
import { Tool } from '../reducers/tools_reducer';

const actionCreator = actionCreatorFactory('Tools');

export const GetTools = actionCreator.async<void, Tool[]>('GET_TOOLS');
